/* unplugin-vue-components disabled */import { render } from "./RadioBtn.vue?vue&type=template&id=37341098&scoped=true"
import script from "./RadioBtn.vue?vue&type=script&lang=js"
export * from "./RadioBtn.vue?vue&type=script&lang=js"

import "./RadioBtn.vue?vue&type=style&index=0&id=37341098&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37341098"]])

export default __exports__